import type { RedcatAnalyticsStore } from '../types/store';
import { SignupTrackEventName } from '../types/signup';
import type { SignupTrackEvent } from '../types/events/track';

export const trackSignupSubmitted = (
  track: RedcatAnalyticsStore['track'],
  {
    startTime,
    fieldsCompletedCount,
    marketingEmailOptIn,
    marketingSmsOptIn,
  }: {
    startTime: number | null;
    fieldsCompletedCount: number;
    marketingEmailOptIn: boolean;
    marketingSmsOptIn: boolean;
  },
) => {
  if (startTime == null) return;

  const event: SignupTrackEvent = {
    name: SignupTrackEventName.Submitted,
    properties: {
      time_in_flow_sec: Number(((Date.now() - startTime) / 1000).toFixed(1)),
      fields_completed_count: fieldsCompletedCount,
      marketing_email_opt_in: marketingEmailOptIn,
      marketing_sms_opt_in: marketingSmsOptIn,
    },
  };

  track(event);
};
